import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'bb-heading-page-ui',
    template: '',
    styles: [],
    standalone: false,
})
export class BbHeadingPageUiComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
